/**
 * Haal het QR-token uit een gescande tekst. Gedeeld door alle scanners (portal,
 * backoffice, magazijn-tablet). Puur, dus ook bruikbaar in een server-action.
 *
 * Formaten:
 *   a) een volledige URL met pad `.../scanner/r/<token>` (of `.../r/<token>`)
 *   b) een kaal token (base64url-tekens, minimaal 8 lang)
 */
export function extractQrToken(raw: string): string | null {
  const trimmed = raw.trim()
  const urlMatch = trimmed.match(/\/(?:scanner\/)?r\/([A-Za-z0-9_-]+)\s*$/)
  if (urlMatch) return urlMatch[1] ?? null
  if (/^[A-Za-z0-9_-]{8,}$/.test(trimmed)) return trimmed
  return null
}

/**
 * batch-71 kiosk-magazijn (FO-532 §B4) - de QR op een medewerkerspas begint hiermee. Het is een
 * inlogmiddel voor de magazijn-tablet: een scanner maakt er nooit een adres van (dan staat het in
 * de browsergeschiedenis en de telemetrie). Puur, dus ook bruikbaar in een server-action.
 */
export const PAS_TOKEN_VOORVOEGSEL = 'pas_'

export function isPasToken(token: string): boolean {
  return token.startsWith(PAS_TOKEN_VOORVOEGSEL)
}
